module.exports = __webpack_public_path__ + "static/media/icon-settings.689b9bb5.svg";